import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import CrearFarmacia from "./Crear";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const Crear = () => {
  document.title = "Crear Farmacia | Farme";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Crear Farmacia"
            pageTitle="Listar Farmacias"
            url="/farmacias"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CrearFarmacia />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Crear;
